import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";

// Suppress innocuous ResizeObserver warnings (documented as non-actionable per the W3C spec).
if (typeof window !== "undefined") {
  const resizeObserverErrorRe = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
  window.addEventListener("error", (e) => {
    if (resizeObserverErrorRe.test(e.message)) {
      e.stopImmediatePropagation();
      const overlay = document.getElementById("webpack-dev-server-client-overlay");
      const overlayDiv = document.getElementById("webpack-dev-server-client-overlay-div");
      if (overlay) overlay.style.display = "none";
      if (overlayDiv) overlayDiv.style.display = "none";
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
